import { render } from "./SegmentExpansion.vue?vue&type=template&id=2c54da52&scoped=true"
import script from "./SegmentExpansion.vue?vue&type=script&lang=js"
export * from "./SegmentExpansion.vue?vue&type=script&lang=js"

import "./SegmentExpansion.vue?vue&type=style&index=0&id=2c54da52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c54da52"]])

export default __exports__